module.exports = __webpack_public_path__ + "static/media/country_bv.fb0bff15.webp";